import { render, staticRenderFns } from "./results-overview.vue?vue&type=template&id=4cc80a6d&scoped=true"
import script from "./results-overview.vue?vue&type=script&lang=ts"
export * from "./results-overview.vue?vue&type=script&lang=ts"
import style0 from "./results-overview.vue?vue&type=style&index=0&id=4cc80a6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc80a6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc80a6d')) {
      api.createRecord('4cc80a6d', component.options)
    } else {
      api.reload('4cc80a6d', component.options)
    }
    module.hot.accept("./results-overview.vue?vue&type=template&id=4cc80a6d&scoped=true", function () {
      api.rerender('4cc80a6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/results/results-overview.vue"
export default component.exports